import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, switchMap} from 'rxjs/operators';
import {PAGES_AND_PATHS} from 'src/app/constants/pages-and-paths';
import {LystTypeFilter} from 'src/app/enums/list-enums';
import {TlPagination} from 'src/app/interfaces/general-interfaces';
import {List} from 'src/app/services/http-services/lists/lists-http-intterfaces';
import {ListsHttpService} from 'src/app/services/http-services/lists/lists-http.service';

@Component({
  selector: 'app-my-lists',
  templateUrl: './my-lists.component.html',
})
export class MyListsComponent implements OnInit {
  pageNum = 1;
  pagination!: TlPagination;
  lists: List[] = [];
  activeListType: LystTypeFilter = LystTypeFilter.allLysts;
  PAGES_AND_PATHS = PAGES_AND_PATHS;
  isReorder = false;
  loading = false;
  search = '';
  searchSubject = new Subject<string>();
  @ViewChild('listsContainter', {static: false}) private listsContainter!: ElementRef;
  allLists = [];

  constructor(
    private listsHttpService: ListsHttpService
  ) {
  }

  ngOnInit(): void {
    this.getMyLystsV2(this.pageNum, this.activeListType);
    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((search: string) => this.getMyLystsV2(this.pageNum, this.activeListType, search))
    ).subscribe((response: any) => {
      this.lists = response.data;
      this.pagination = response.pagination;
    });
  }

  getMyLystsV2(pageNumber: number, filter: LystTypeFilter, search?: string): Promise<any> {
    this.loading = true;
    return new Promise((resolve, reject) => {
      this.listsHttpService.getMyLystsV2(pageNumber, filter, search).then((res: any) => {
        try {
          this.lists = [...this.lists, ...res.data];
          this.pagination = res.pagination;
          this.loading = false;
        } catch (e) {
        }
        this.getAllListsForReorder();
        this.pagination = res.pagination;
        resolve(res);
      }, error => {
        reject(false);
      });
    });
  }

  changeListType(filter: LystTypeFilter): void {
    this.activeListType = filter;
    this.lists = [];
    this.pageNum = 1;
    this.getMyLystsV2(this.pageNum, this.activeListType);
  }

  reorder(): void {
    if (this.activeListType !== LystTypeFilter.allLysts) {
      this.changeListType(LystTypeFilter.allLysts);
    }
    this.isReorder = !this.isReorder;
    this.lists = [];
    if (this.isReorder) {
      this.lists = this.allLists;
    } else {
      this.getMyLystsV2(1, this.activeListType);
    }
  }

  onScroll(event: any): void {
    if (!this.isReorder) {
      const container = this.listsContainter.nativeElement;
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;

      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

      if (!this.loading && isAtBottom && ((this.pagination?.currentPage ?? 0) < (this.pagination?.lastPage ?? 0))) {
        this.pageNum++;
        this.getMyLystsV2(this.pageNum, this.activeListType);
      }
    }
  }

  drop(event: CdkDragDrop<any[]>): void {
    if (this.isReorder) {
      moveItemInArray(this.lists, event.previousIndex, event.currentIndex);

      const reorderedList = this.lists.map((item, index) => ({
        id: item.id,
        order_value: this.lists.length - index
      }));

      const reqObj = {order: reorderedList};
      this.listsHttpService.reorderLists(reqObj).then((res: any) => {
      });
    }
  }

  onSearchChange(event: any): void {
    this.search = event.target.value;
    this.pageNum = 1;
    this.lists = [];
    this.searchSubject.next(this.search);
  }

  resetSearch(): void {
    this.search = '';
    this.searchSubject.next('');
  }

  getAllListsForReorder(): void {
    this.listsHttpService.getAllListsForReorder().then((res: any) => {
      this.allLists = res.data;
    });
  }

  protected readonly LystTypeFilter = LystTypeFilter;
}
